import styled from '@emotion/styled/macro';
import Input from 'src/components/ui/inputs/input/Input';

export const CustomInput = styled(Input)`
  max-width: 250px;
  margin-right: ${({ theme }) => theme.spacing.m};
`;
